import script from "./JobManager.vue?vue&type=script&setup=true&lang=js"
export * from "./JobManager.vue?vue&type=script&setup=true&lang=js"

import "./JobManager.vue?vue&type=style&index=0&id=12682e00&scoped=true&lang=css"
script.__scopeId = "data-v-12682e00"

export default script